import { useTranslation } from 'next-i18next'
import { FC, useEffect, useMemo } from 'react'

import Accordion from '@/components/Accordion'
import Heading from '@/components/Heading'
import Meta from '@/components/Meta'

import { TextDataType } from '@/types/TextData'

import styles from './Texts.module.scss'
import { useTexts } from '@/bus/texts'
import { Content } from '@/layouts'

const regexp = new RegExp(/style="(.*?)"/gm)

interface Props {
  data?: TextDataType
  slug: string
}

export const Texts: FC<Props> = ({ data = {}, slug }) => {
  const { getTextsBySlug, clearTexts, data: dataText = {} } = useTexts()
  const {
    t,
    i18n: { language: lang }
  } = useTranslation(slug)

  useEffect(() => {
    getTextsBySlug({ slug, lang })

    return () => {
      clearTexts()
    }
    // eslint-disable-next-line
  }, [slug, lang])

  const page = useMemo(() => ({ ...data, ...dataText }), [dataText, data])
  const title = page.title || (t('title', { defaultValue: '' }) as string)

  return (
    <>
      <Meta {...(page.meta || {})} title={page.meta?.title || title || null} />
      <Content>
        <div className={styles['texts']}>
          <Heading className={styles['texts__heading']} level={1}>
            {title}
          </Heading>
          <div
            className={styles['texts__content']}
            dangerouslySetInnerHTML={{
              __html: (page.content || '')
                .replace(regexp, '')
                .replace(/&zwj;/g, '')
            }}
          />
          {!!page.children?.length && <Accordion items={page.children} />}
        </div>
      </Content>
    </>
  )
}
